// removed by extract-text-webpack-plugin
module.exports = {"card":"styles--card--2jpVOPCB","save-button":"styles--save-button--Enpwe3sF","saveButton":"styles--save-button--Enpwe3sF"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/BaseSettingsPage/styles.css
// module id = 1239
// module chunks = 2